import { render, staticRenderFns } from "./companyPoundSystemConfig.vue?vue&type=template&id=66c935ca&scoped=true&"
import script from "./companyPoundSystemConfig.vue?vue&type=script&lang=js&"
export * from "./companyPoundSystemConfig.vue?vue&type=script&lang=js&"
import style0 from "./companyPoundSystemConfig.vue?vue&type=style&index=0&id=66c935ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c935ca",
  null
  
)

export default component.exports